<script>
  export default {
    name: "WidgetCallout",
    props: {
      /** The widgets title */
      title: {
        type: String,
        required: true
      },
      /** Callout text included in the widget */
      text: {
        type: String,
        default: null
      },
      /** URL string for the button */
      link: {
        type: String,
        default: null
      },
      /** Label for the button */
      label: {
        type: String,
        default: 'Learn More'
      }
    }
  }
</script>

<template>
  <article class="callout--type2 m-large m-sidebar">
    <div class="callout__inner">
      <h3 v-if="text" class="callout__title" v-html="text" />
      <a v-if="link" :href="link" class="callout__cta button--transparent m-full">{{ label }}</a>
    </div>
  </article>
</template>
